var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{attrs:{"hide-details":true,"rules":_vm.rules}},[_c('div',{staticClass:"admin-field-wrapper mt-2 mb-4"},[(_vm.label)?_c('div',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }